// extracted by mini-css-extract-plugin
export default {"contentClickAway":"styles_contentClickAway__EO-Ff"};